import { cn } from '@/lib/utils'

type BadgeVariant = 'blue' | 'orange' | 'green' | 'gray' | 'purple'

interface BadgeProps {
  variant?: BadgeVariant
  children: React.ReactNode
  className?: string
}

const variantStyles: Record<BadgeVariant, string> = {
  blue: 'bg-[var(--accent-blue-light)] text-[var(--accent-blue)]',
  orange: 'bg-[var(--accent-orange-light)] text-[var(--accent-orange)]',
  green: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-400',
  gray: 'bg-[var(--bg-tertiary)] text-[var(--text-secondary)]',
  purple: 'bg-purple-50 text-purple-700 dark:bg-purple-950 dark:text-purple-400',
}

export function Badge({ variant = 'gray', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium',
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
